import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

const googleSourcingInfoFromDeviceModelApi = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunction(data,apiConstants.OBJECT_RECOGNITION.GOOGLE_SOURCING_INFO_FROM_DEVICE_MODEL)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default googleSourcingInfoFromDeviceModelApi;
